// extracted by mini-css-extract-plugin
export var container = "USPBanner-module--container--3t4jq";
export var content = "USPBanner-module--content--2YzTk";
export var link = "USPBanner-module--link--3Tspk";
export var linkNotClickable = "USPBanner-module--linkNotClickable--1JRrb";
export var linkText = "USPBanner-module--linkText--2ZQaM";
export var separator = "USPBanner-module--separator--2yP_b";